import '../styles/index.css';
import { useLanguage } from '../context/LanguageContext';

export default function Panorama() {
    const { language } = useLanguage();

    return (
        <div className='p-5 text-center bg-image' data-aos="fade">
            <div className='mask' style={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }}>
                <div className='d-flex justify-content-center align-items-center h-100'>
                    <div className='text-white text-on-panorama'>
                        <h1 className='mb-3 display-3'>
                            {language === 'EN' 
                                ? 'LEADING HVAC SOLUTIONS' 
                                : 'SOLUȚII MODERNE PENTRU MICROCLIMĂ'}
                        </h1>
                        <h1 className="mb-3 display-5">
                            {language === 'EN' 
                                ? 'FROM PRIVATE HOMES TO INDUSTRIAL FACILITIES' 
                                : 'PENTRU LOCUINȚE PRIVATE ȘI SPAȚII INDUSTRIALE'}
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    );
}